<template>
  <div class="accordion-container">
    <div class="accordion-header" @click="toggleExpanded">
      <slot name="header" />
      <!-- Will be using only arrow icon for all our designs as per designer -->
      <UiIcon
        v-if="hasToggleIcon"
        name="chevron"
        size="14px"
        :rotate-deg="isExpanded ? 90 : 270"
        class="toggle-icon"
        :is-clickable="true"
      />
    </div>
    <Transition name="slide">
      <slot v-if="isExpanded" name="content" />
    </Transition>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import UiIcon from '@sephora-asia/ui-icon/UiIcon.vue'

interface Props {
  isInitiallyExpanded?: boolean
  hasToggleIcon?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  isInitiallyExpanded: false,
  hasToggleIcon: true,
})

const isExpanded = ref(props.isInitiallyExpanded)

function toggleExpanded(): void {
  isExpanded.value = !isExpanded.value
}
</script>

<style lang="scss" scoped>
.accordion-header {
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  position: relative;
  padding-bottom: 8px;
  @extend .headline-m;
}

:deep(.toggle-icon > svg) {
  transition-delay: 0.15s;
}

.slide-enter-active {
  transition-duration: 0.8s;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  transition-delay: -0.3s;
  transition-duration: 0.8s;
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}
.slide-enter-to,
.slide-leave-from {
  max-height: 3000px;
  overflow: hidden;
}

.slide-enter-from,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}
.toggle-icon {
  margin-left: 8px;
}
</style>
